module.exports = __webpack_public_path__ + "img/coin.6381b704.png";